import { Link } from "react-router-dom";
import { PiPlusBold } from "react-icons/pi";
import CreateEditProduct from "@/app/shared/ecommerce/product/create-edit";
import { metaObject } from "@/config/site.config";
import PageHeader from "@/app/shared/page-header";
import { Button } from "rizzui";
import routes from "@/routers/routes";

export const metadata = {
  ...metaObject("Create Product"),
};

const pageHeader = {
  title: "Create Product",
  breadcrumb: [
    {
      href: routes.eCommerce.dashboard,
      name: "E-Commerce",
    },
    {
      href: routes.eCommerce.products,
      name: "Products",
    },
    {
      name: "Create",
    },
  ],
};

export default function CreateProductPage() {
  return (
    <>
      <PageHeader title={pageHeader.title} breadcrumb={pageHeader.breadcrumb}>
        <Link
          to={routes.eCommerce.createProduct}
          className="mt-4 w-full @lg:mt-0 @lg:w-auto"
        >
          <Button as="span" className="w-full @lg:w-auto">
            <PiPlusBold className="me-1.5 h-[17px] w-[17px]" />
            Add Product
          </Button>
        </Link>
      </PageHeader>

      <CreateEditProduct />
    </>
  );
}
